import { axios } from "../helpers"

export default {
    state: {
        themesData: [],
        themesLoadStatus: 0,
    },
    getters: {
        getThemesData(state) {
            return state.themesData
        },
        getThemesLoadStatus(state) {
            return state.themesLoadStatus
        },
    },
    mutations: {
        setThemesData(state, themesData) {
            state.themesData = themesData;
        },
        setThemesLoadStatus(state, status) {
            state.themesLoadStatus = status;
        },
    },
    actions: {
        loadThemesData({commit}, data) {
            commit('setThemesLoadStatus', 1);

            axios
                .get(data.locale + '/themes')
                    .then(response => {
                        commit('setThemesData', response.data);
                        commit('setThemesLoadStatus', 2);
                    }).catch(() => {
                        commit('setThemesData', {});
                        commit('setThemesLoadStatus', 3);
                    });
        },
    }
}
